// apps/dashboard/src/main.tsx
// React 19 + Vite entry point.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './i18n'; // initialise i18next before rendering
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
